"use client"

import { Skeleton } from "@rarible_int/anaconda_ui_components"
import dynamic from "next/dynamic"

export const DynamicChart = dynamic(
  () => import("./chart").then((mod) => mod.Chart),
  {
    ssr: false,
    loading: () => <Skeleton className="h-0.5 w-20" />,
  },
)

export function Chart({ chartData }: { chartData: number[] }) {
  return (
    <ChartWrapper>
      <DynamicChart chartData={chartData} />
    </ChartWrapper>
  )
}

export function ChartSkeleton() {
  return (
    <ChartWrapper>
      <Skeleton className="h-0.5 w-20" />
    </ChartWrapper>
  )
}

export function ChartWrapper(props: React.PropsWithChildren) {
  return (
    <div className="flex h-full w-full items-center justify-end">
      {props.children}
    </div>
  )
}
